import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router";

// New pages must open at the top. <ScrollRestoration> resets scroll once, at
// the moment the route commits — but most routes are lazy chunks behind a
// Suspense fallback, and on a slow phone the real page (and its data) arrives
// later. Tapping a footer link left «Тандалгандар» or a region page sitting
// at the footer, and «Жарыя берүү» 440 px down. So: on every PUSH/REPLACE to
// a new path (no #hash — ScrollToHash handles those) reset now and again
// while the page settles, unless the person has started scrolling.
// Back/forward (POP) is left to ScrollRestoration.
const SETTLE_DELAYS = [0, 60, 200, 450, 900];

export function ScrollToTop() {
  const { pathname, hash } = useLocation();
  const navType = useNavigationType();

  useLayoutEffect(() => {
    if (navType === "POP" || hash) return;
    let userScrolled = false;
    const stop = () => {
      userScrolled = true;
    };
    const opts = { passive: true } as const;
    window.addEventListener("wheel", stop, opts);
    window.addEventListener("touchmove", stop, opts);
    window.addEventListener("keydown", stop, opts);

    const toTop = () => {
      if (!userScrolled && window.scrollY !== 0) window.scrollTo({ top: 0, left: 0, behavior: "instant" as ScrollBehavior });
    };
    toTop();
    const timers = SETTLE_DELAYS.map((ms) => window.setTimeout(toTop, ms));
    return () => {
      timers.forEach(clearTimeout);
      window.removeEventListener("wheel", stop);
      window.removeEventListener("touchmove", stop);
      window.removeEventListener("keydown", stop);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
